export default function TenureBadge({ children, role = '', className = '' }) {
  const badgeClass = role === 'Veteran' || role === 'Closer' ? 'bg-yellow-100 text-yellow-500' : 'bg-gray-100 text-gray-500';
  return (
    <div className={`${badgeClass} flex justify-center items-center text-xs rounded-full max-w-min px-2 py-1 ${className}`}>
      {children}
    </div>
  );
}
